<template>
	<ais-instant-search
    :search-client="searchClient"
    :index-name="index">
		<div class="row">
			<div class="col-md-3">
				<ais-clear-refinements />
				<h2>PPE</h2>
			  <ais-refinement-list
					attribute="items"
					:class-names="{
						'ais-RefinementList-list': 'supplier-list'
						}"/>
			</div>
			<div class="col-md-9">
				<ais-search-box
					:class-names="{
						'ais-SearchBox': 'col-md-6',
	    			'ais-SearchBox-input': 'form-control',
						'ais-SearchBox-form': 'input-group'
	  			}">
				  <div slot="reset-icon">
						<div class="input-group-append">
	        		<span class="input-group-text"><i class="fa fa-times"></i></span>
	      		</div>
					</div>
					<div slot="submit-icon">
						<div class="input-group-append">
							<span class="input-group-text"><i class="fa fa-search"></i></span>
						</div>
					</div>
				</ais-search-box>
				<app-map />
				<ais-hits
				  :class-names="{
				    'ais-Hits': 'supplier',
				    'ais-Hits-list': 'supplier-list',
				  }">
					<div slot="item" slot-scope="{ item }">
						<div class="card-body">
							<h3 class="card-title">{{ item.companyName }}</h3>
							<ul style="list-style:none;">
								<li v-for="ppe in item.items"
										:key="ppe.index">{{ ppe }}</li>
							</ul>
						</div>
					</div>
				</ais-hits>
			</div>
		</div>
  </ais-instant-search>
</template>

<style>
.supplier-list {
	list-style: none;
}
</style>

<script>
import algoliasearch from 'algoliasearch/lite';
import AppMap from './components/Map';
import {ALGOLIA_INDEX_NAME, ALGOLIA_SEARCH_API_KEY} from '../config.js';

export default {
	components: { AppMap },
  data() {
    return {
      index: ALGOLIA_INDEX_NAME,
      searchClient: algoliasearch(
        'JLTOCOZGTU',
        ALGOLIA_SEARCH_API_KEY
      ),
    };
  },
};
</script>
